import login from './login'
import logout from './logout'
import errors from './errors'
import application from './application'
import print from './print'

// const root = {
//   path: '/',
//   redirect: '/home',
// }

export default [...login, ...errors, ...logout, ...application, ...print]
